//
// Game Display State
//
// Tracks and manages pig display levels for visual feedback
// ----------------------------

gameDisplayState = function () {
  // this.displayLevels = {
  //   red: 0,    // freespins
  //   blue: 0,   // jp freespins
  //   green: 0,  // elimination spins
  //   gold: 0    // wheel
  // };
  
  // this.featureMapping = {
  //   'freespins': 'red',
  //   'jp freespins': 'blue',
  //   'elimination spins': 'green',
  //   'wheel': 'gold'
  // };
  
  this.coinToPigMapping = {
    11: 'red',
    12: 'gold',
    13: 'green',
    14: 'blue'
  };
  
  // Map featureType to pig color
  this.featureTypeToPig = {
    1: 'red',    // Standard Only
    2: 'blue',   // Jackpot Only
    3: 'green',  // Elimination Only
    4: ['red', 'blue'],    // Standard And Jackpot
    5: ['red', 'green'],   // Standard And Elimination
    6: ['blue', 'green'],  // Jackpot And Elimination
    7: ['red', 'blue', 'green'] // All Three
  };
};

// gameDisplayState.prototype.initialize = function(defaultFeatureState) {
//   // Set initial display levels from config
//   if (defaultFeatureState) {
//     this.displayLevels.red = defaultFeatureState['freespins'] && 
//       defaultFeatureState['freespins'].featureDisplayLevelIndex || 0;
//     this.displayLevels.blue = defaultFeatureState['jp freespins'] && 
//       defaultFeatureState['jp freespins'].featureDisplayLevelIndex || 0;
//     this.displayLevels.green = defaultFeatureState['elimination spins'] && 
//       defaultFeatureState['elimination spins'].featureDisplayLevelIndex || 0;
//     this.displayLevels.gold = defaultFeatureState['wheel'] && 
//       defaultFeatureState['wheel'].featureDisplayLevelIndex || 0;
//   }
// };

// gameDisplayState.prototype.updateFromDisplayState = function(displayState) {
//   const changes = [];
  
//   if (displayState.freeSpinsDisplayLevelIndex !== undefined && 
//       displayState.freeSpinsDisplayLevelIndex !== this.displayLevels.red) {
//     changes.push({
//       pig: 'red',
//       oldLevel: this.displayLevels.red,
//       newLevel: displayState.freeSpinsDisplayLevelIndex,
//       levelIncreased: displayState.freeSpinsDisplayLevelIndex > this.displayLevels.red
//     });
//     this.displayLevels.red = displayState.freeSpinsDisplayLevelIndex;
//   }
  
//   if (displayState.jpSpinsDisplayLevelIndex !== undefined && 
//       displayState.jpSpinsDisplayLevelIndex !== this.displayLevels.blue) {
//     changes.push({
//       pig: 'blue',
//       oldLevel: this.displayLevels.blue,
//       newLevel: displayState.jpSpinsDisplayLevelIndex,
//       levelIncreased: displayState.jpSpinsDisplayLevelIndex > this.displayLevels.blue
//     });
//     this.displayLevels.blue = displayState.jpSpinsDisplayLevelIndex;
//   }
  
//   if (displayState.eliminationsDisplayLevelIndex !== undefined && 
//       displayState.eliminationsDisplayLevelIndex !== this.displayLevels.green) {
//     changes.push({
//       pig: 'green',
//       oldLevel: this.displayLevels.green,
//       newLevel: displayState.eliminationsDisplayLevelIndex,
//       levelIncreased: displayState.eliminationsDisplayLevelIndex > this.displayLevels.green
//     });
//     this.displayLevels.green = displayState.eliminationsDisplayLevelIndex;
//   }
  
//   if (displayState.wheelDisplayLevelIndex !== undefined && 
//       displayState.wheelDisplayLevelIndex !== this.displayLevels.gold) {
//     changes.push({
//       pig: 'gold',
//       oldLevel: this.displayLevels.gold,
//       newLevel: displayState.wheelDisplayLevelIndex,
//       levelIncreased: displayState.wheelDisplayLevelIndex > this.displayLevels.gold
//     });
//     this.displayLevels.gold = displayState.wheelDisplayLevelIndex;
//   }
  
//   return changes;
// };

gameDisplayState.prototype.getFeaturePigs = function(featureType) {
  const pigs = this.featureTypeToPig[featureType];
  return Array.isArray(pigs) ? pigs : [pigs];
};

// gameDisplayState.prototype.getDisplayLevel = function(pigColor) {
//   return this.displayLevels[pigColor] || 0;
// };

gameDisplayState.prototype.getPigFromCoinSymbol = function(coinSymbol) {
  return this.coinToPigMapping[coinSymbol];
};

// gameDisplayState.prototype.reset = function() {
//   this.displayLevels.red = 0;
//   this.displayLevels.blue = 0;
//   this.displayLevels.green = 0;
//   this.displayLevels.gold = 0;
// };